import { api } from '../../api-helper';
import { URLS } from '../../../constants/URLS';

export const getSignedURL = (fileKey, sfdt = false) => {
  return api.post(
    URLS.storage,
    { key: fileKey, sfdt: sfdt },
    {
      headers: {
        needsToken: true
      }
    }
  );
};

export const addAddress = (addressData, withLocation = false) => {
  return api.post(
    URLS.address,
    { ...addressData, withLocation: withLocation },
    {
      headers: {
        needsToken: true
      }
    }
  );
};

export const updateAddress = (addressData, withLocation = false) => {
  return api.put(
    URLS.address,
    { ...addressData, withLocation: withLocation },
    {
      headers: {
        needsToken: true
      }
    }
  );
};

export const getZipCodeAutofill = (zipCode) => {
  return api.post(`${URLS.getZipCodeAutofill}`, null, {
    params: {
      zipCode: zipCode
    },

    headers: {
      needsToken: true
    }
  });
};

export const autofillAddress = (inputSearch) => {
  return api.post(
    URLS.autofillAddress,
    {
      partialAddress: inputSearch
    },
    {
      headers: {
        needsToken: true
      }
    }
  );
};

export const getCoordinateFromAddress = (address) => {
  return api.post(
    URLS.coordinateFromAddress,
    { ...address },
    {
      headers: {
        needsToken: true
      }
    }
  );
};

export const getAddressFromId = (placeID, addressComponents = false) => {
  return api.post(
    URLS.getAddressFromId,
    {
      id: placeID,
      addressComponents: addressComponents
    },
    {
      headers: {
        needsToken: true
      }
    }
  );
};

export const getAddressFromCoords = (latLngObj) => {
  return api.post(URLS.getAddressFromCoords, latLngObj, {
    headers: {
      needsToken: true
    }
  });
};

export const getMilestoneStatusesOptionsList = () => {
  return api.get(URLS.getMilestoneStatuses, {
    headers: {
      needsToken: true
    }
  });
};

export const getNewTaskTitles = () => {
  return api.get(URLS.taskTitles, {
    headers: {
      needsToken: true
    }
  });
};

export const getStates = (query, limit = 5) => {
  return api.get(URLS.states, {
    params: {
      ...(query && { query: query }),
      limit: limit
    },
    headers: {
      needsToken: true
    }
  });
};

export const getCountry = (query, stateName, limit = 5) => {
  return api.get(URLS.counties, {
    params: {
      ...(query && { query: query }),
      ...(stateName && { stateName: stateName }),
      limit: limit
    },
    headers: {
      needsToken: true
    }
  });
};

export const getTowns = (query, countyName, limit = 5) => {
  return api.get(URLS.towns, {
    params: {
      ...(query && { query: query }),
      ...(countyName && { countyName: countyName }),
      limit: limit
    },
    headers: {
      needsToken: true
    }
  });
};

export const getRecentVisits = (isProject = false) => {
  return api.post(
    URLS.getVisits,
    { isProject: isProject },
    {
      headers: {
        needsToken: true
      }
    }
  );
};

export const saveVisit = (orderID, projectID) => {
  return api.put(
    URLS.saveVisit,
    {
      ...(orderID && { orderID: orderID }),
      ...(projectID && { projectID: projectID })
    },
    {
      headers: {
        needsToken: true
      }
    }
  );
};

export const getAttachmentDocumentsTypes = (
  query,
  page = 1,
  limit = 10,
  all = false
) => {
  return api.get(URLS.documentsTypes, {
    params: {
      ...(query && { query }),
      ...(all ? { all: true } : { page: page, limit: limit })
    },
    headers: {
      needsToken: true
    }
  });
};

export const getEntity = () => {
  return api.get(URLS.entity, {
    headers: {
      needsToken: true
    }
  });
};

export const getProduct = (clientID, projectID) => {
  return api.get(URLS.producttypes, {
    params: {
      ...(clientID && { clientID: clientID }),
      ...(projectID && { projectID: projectID })
    },

    headers: {
      needsToken: true
    }
  });
};

// Control-center listing of products with their client-facing alias/description.
// It is a POST because the filters travel in the body. `hasDescription` is
// tri-state: null means "no filter", so it is only sent when set.
export const getClientFacingProducts = ({
  page,
  limit,
  query,
  hasDescription
}) => {
  return api.post(
    URLS.clientFacingProducts,
    {
      page: page,
      limit: limit,
      query: query || '',
      ...(hasDescription !== null &&
        hasDescription !== undefined && { hasDescription: hasDescription })
    },
    {
      headers: {
        needsToken: true
      }
    }
  );
};

// `alias` is required; `description` may be null to clear it.
export const updateClientFacingProduct = ({ id, alias, description }) => {
  return api.put(
    URLS.clientFacingProducts,
    {
      id: id,
      alias: alias,
      description: description
    },
    {
      headers: {
        needsToken: true
      }
    }
  );
};

// Soft check run before saving: reports whether the alias collides with another
// product's alias or internal name. Both are warnings the admin can override,
// not errors, so this never blocks the update by itself.
export const validateClientFacingProductAlias = ({ id, alias }) => {
  return api.post(
    URLS.clientFacingProductsValidate,
    {
      alias: alias
    },
    {
      params: {
        id: id
      },

      headers: {
        needsToken: true
      }
    }
  );
};

export const getAssetsTypes = (limit = 100) => {
  return api.get(URLS.assettypes, {
    params: {
      limit: limit
    },
    headers: {
      needsToken: true
    }
  });
};

export const getClinets = (searchQuery, all = true) => {
  return api.get(
    `${URLS.clients}?all=${all}${searchQuery ? '&query=' + searchQuery : ''}`,
    {
      headers: {
        needsToken: true
      }
    }
  );
};

export const getTeamsList = (searchQuery, pagination, limit) => {
  return api.get(URLS.teamsName, {
    params: {
      ...(searchQuery && { query: searchQuery }),
      ...(typeof pagination === 'boolean' && { pagination: pagination }),
      ...(limit && { limit: limit })
    },
    headers: {
      needsToken: true
    }
  });
};

export const getMembersList = (teamID, searchQuery, pagination, excludeID) => {
  return api.get(
    `${URLS.members}?${teamID ? `teamID=${teamID}` : ''}${
      searchQuery ? `&query=${searchQuery}` : ''
    }${typeof pagination === 'boolean' ? `&pagination=${pagination}` : ''}${
      excludeID?.length ? `&excludeID=${excludeID}` : ''
    }`,
    {
      headers: {
        needsToken: true
      }
    }
  );
};

export const getUserTeams = () => {
  return api.get(URLS.userTeams, {
    headers: {
      needsToken: true
    }
  });
};

export const getClientOrderNumbers = (searchQuery, projectID) => {
  return api.get(URLS.clientOrderNumbers, {
    params: {
      ...(searchQuery && { query: searchQuery }),
      ...(projectID && { projectID: projectID })
    },
    headers: {
      needsToken: true
    }
  });
};

export const getSiteNames = (searchQuery) => {
  return api.get(
    `${URLS.siteNames}?${searchQuery ? `query=${searchQuery}` : ''}`,
    {
      headers: {
        needsToken: true
      }
    }
  );
};

export const getChannelAccessToken = (channelData) => {
  return api.post(URLS.getChannelAccessToken, channelData, {
    headers: {
      needsToken: true
    }
  });
};
